'use client';

import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from '../../lib/cn';

export type AvatarStatus = 'online' | 'away' | 'offline';

export interface AvatarProps {
  src?: string;
  name?: string;
  /** Pixel size of the square/circle. */
  size?: number;
  status?: AvatarStatus;
  square?: boolean;
  className?: string;
}

const statusColor: Record<AvatarStatus, string> = {
  online: 'bg-[var(--color-online)]',
  away: 'bg-warning',
  offline: 'bg-[var(--color-text-muted)]',
};

export function Avatar({ src, name = '', size = 36, status, square = false, className }: AvatarProps) {
  const initial = name.trim().charAt(0).toUpperCase() || '?';
  return (
    <div className={cn('relative shrink-0', className)} style={{ width: size, height: size }}>
      <AvatarPrimitive.Root
        className={cn(
          'flex size-full items-center justify-center overflow-hidden bg-accent',
          square ? 'rounded-md' : 'rounded-full',
        )}
      >
        {src ? (
          <AvatarPrimitive.Image src={src} alt={name} className="size-full object-cover" />
        ) : null}
        <AvatarPrimitive.Fallback
          delayMs={src ? 300 : 0}
          className="flex size-full items-center justify-center font-sans font-bold text-accent-fg"
          style={{ fontSize: size * 0.4 }}
        >
          {initial}
        </AvatarPrimitive.Fallback>
      </AvatarPrimitive.Root>
      {status ? (
        <span
          className={cn('absolute bottom-0 right-0 rounded-full border-2 border-surface', statusColor[status])}
          style={{ width: size * 0.28, height: size * 0.28 }}
        />
      ) : null}
    </div>
  );
}
